@if (isLoading | async) {
  <div class="griot-loader">
    <img
      src="assets/images/logo/icon.png"
      alt="loader logo"
      class="loader-logo"
    />
  </div>
}
